import {SYSTEM_DASHBOARD_ROLES} from "../../utilities/roleAccess.jsx"

export const METRIC_NAVBAR_LINKS = [
    {
        key: "Metrics-Dashboard",
        name: "Metrics Dashboard",
        description: "Overview, compliance, performance, financial, and demographic metrics.",
        icon: "fa-chart-simple",
        link: "/metrics/dashboard",
        roleRequired: SYSTEM_DASHBOARD_ROLES,
        skip: false,
    },
]
